import React, { useEffect, useContext, useState } from "react";
import { Modal } from "reactstrap";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";

import AuthView from "./AuthView";
import CheckoutView from "./CheckoutView";
import ThankYouView from "./ThankYouView";
import { TierItem } from "../../../typings/pricing";
import { SubscriptionContext } from "../../../services/SubscriptionService";
import styles from "./styles.scss";
import AnalyticsService from "src/services/AnalyticsService";

export interface CheckoutModalProps {
  selectedTier: TierItem;
  upsellTier?: TierItem;
  visible: boolean;
  toggleModal(): void;
  upgradeSource: string | null;
}

const CheckoutModal = ({ visible, toggleModal, selectedTier, upsellTier, upgradeSource }: CheckoutModalProps) => {
  const ctx = useContext(SubscriptionContext);
  const [disabled, setDisabled] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [invoiceId, setInvoiceId] = useState("");

  // Sign in tab switch
  useEffect(() => {
    setTabIndex(ctx.signedIn ? 1 : 0);
  }, [ctx.signedIn]);

  // If the thing just became visible or we changed tabs, log the view
  useEffect(() => {
    if (!visible) {
      return;
    }
    AnalyticsService.track("Checkout Modal View", {
      screen: "CheckoutModal",
      page: "Pricing",
      tab: selectedTier.durationTitle,
      subscriptionLevel: `${selectedTier.title} ${selectedTier.durationTitle}`,
      step: tabIndex === 0 ? "Auth" : tabIndex === 1 ? "Checkout" : "Thank You", // prettier-ignore
      upgradeSource,
    });
  }, [visible, tabIndex]);

  return (
    <Modal
      className={`rotoql-checkout-modal__dialog ${
        tabIndex === 0
          ? "rotoql-checkout-modal__dialog--auth"
          : tabIndex === 1
          ? "rotoql-checkout-modal__dialog--checkout"
          : tabIndex === 2
          ? "rotoql-checkout-modal__dialog--thankyou"
          : ""
      }`}
      contentClassName="rotoql-checkout-modal__content"
      modalClassName="rotoql-checkout-modal"
      wrapClassName="rotoql-checkout-modal__wrapper"
      backdropClassName="rotoql-checkout-modal__backdrop"
      isOpen={visible}
      slide="false"
      size="lg"
      centered
    >
      <div className="rotoql-checkout-modal__close" onClick={() => !disabled && toggleModal()}>
        <Icon path={mdiClose} size="20px" color="#262626" />
      </div>
      {tabIndex === 0 && <AuthView />}
      {tabIndex === 1 && (
        <CheckoutView
          selectedTier={selectedTier}
          upsellTier={upsellTier}
          toggleModal={toggleModal}
          setTabIndex={setTabIndex}
          toggleDisabled={() => setDisabled(!disabled)}
          setInvoice={(value) => setInvoiceId(value)}
        />
      )}
      {tabIndex === 2 && <ThankYouView selectedTier={selectedTier} invoiceId={invoiceId} />}
      <style jsx>{styles}</style>
    </Modal>
  );
};

export default CheckoutModal;
